import {history} from 'instantsearch.js/es/lib/routers';
import components from '../algolia';

export default {
  name: 'MoreCaseStudies',
  components,
  data() {
    const indexName = this.$algolia.indexPrefix + 'case_studies';

    const routing = {
      router: history(),
      stateMapping: {
        stateToRoute(uiState) {
          const indexUiState = uiState[indexName] || {};
          return {industry: indexUiState.menu?.industry};
        },
        routeToState(routeState) {
          return {
            [indexName]: {
              menu: {industry: routeState.industry}
            }
          };
        }
      }
    };

    return {
      indexName,
      routing
    };
  }
};
